import { useCallback } from 'react';

type P = {
  max: number;
  value: number;
};

export const useGetProgressPercent = () =>
  useCallback(({ max, value }: P) => {
    if (!Number.isFinite(value) || !Number.isFinite(max) || max <= 0) {
      return 0;
    }

    const percent = (value / max) * 100;

    return Math.min(100, Math.max(0, percent));
  }, []);
